module.exports = __webpack_public_path__ + "src/assets/textures/env/windmill/windmill_wood_2k_bake.png";